export class ConversationsFilterModal {
    ConversationId: number;
    pageSize: number;
    pageNumber: number;
}
